import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * メッセージ送信 API 操作クラス
 */
export default class SendMessages {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * POST SendMessages to family
   */
  public async postToFamilies(userStore: LoginUser, requestBody: SendMessagesToFamiliesPostModel): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.facility.id
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.SendMessagesToFamily, formatParams);
    const response = await this.commonService.executePost<any>(userStore, requestUrl, requestBody, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }

  /**
   * POST SendMessages to otherUser
   */
  public async postToOtherUser(userStore: LoginUser, requestBody: SendMessagesToOtherUserGroupsPostModel): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.facility.id
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.SendOtherUserGroupMessages, formatParams);
    const response = await this.commonService.executePost<any>(userStore, requestUrl, requestBody, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}

export interface SendMessagesToFamiliesPostModel {
  /** 宛先名 */
  targetName: string;
  /** 宛先ソートキー（LINE） */
  sortKeysForLine: string[];
  /** 宛先ソートキー（メール） */
  sortKeysForMail: string[];
  /** 予約送信日時 */
  scheduledTime: number | null;
  /** 下書きメッセージID */
  draftMessageId: number | null;
  /** 下書きメッセージステータス（承諾送信時: 'approved'） */
  draftMessageStatus: string | null;

  /** メッセージを同一利用者の家族間でシェアするか否か */
  isSharedMessages: boolean;

  /** タイトル */
  title: string;
  /** メッセージ */
  message: string;
  /** オプション文をつけるか */
  addOptionText: boolean;
  /** 見ましたをつけるか */
  addReadButton: boolean;
  /** 返信をつけるか */
  addReplyButton: boolean;

  /** 送信者ID */
  writerId: string;
  /** 送信者名 */
  writtenBy: string;

  /** 添付ファイルのS3URL */
  fileUrls: Array<string>;
  /** 添付ファイル名 */
  fileNames: Array<string>;

  /** 種別 */
  type: SendMessageType;
}

export enum SendMessageType {
  /** 家族全員 */
  ALL_FAMILY = "0",
  /** 家族個別 */
  SELECTED_FAMILY = "1",
  /** 施設関係者個別 */
  SELECTED_OTHER_USER_GROUP = "2",
  /** 宛先グループ */
  SEND_MESSGE_GROUP = "3",
  /** 入居申込者全員 */
  ALL_WAITER = "4",
  /** 入居申込者個別 */
  SELECTED_WAITER = "5",
  /** 利用者グループ */
  RESIDENT_GROUP = "6",
  /** 施設関係者グループ */
  OTHER_USER_GROUP = "7"
}

export interface SendMessagesToOtherUserGroupsPostModel {
  /** 宛先名 */
  targetName: string;
  /** 宛先ソートキー（LINE） */
  sortKeysForLine: string[];
  /** 宛先ソートキー（メール） */
  sortKeysForMail: string[];
  /** 予約送信日時 */
  scheduledTime: number | null;
  /** 下書きメッセージID */
  draftMessageId: number | null;
  /** 下書きメッセージステータス（承諾送信時: 'approved'） */
  draftMessageStatus: string | null;

  /** タイトル */
  title: string;
  /** メッセージ */
  message: string;
  /** オプション文をつけるか */
  addOptionText: boolean;
  /** 見ましたをつけるか */
  addReadButton: boolean;
  /** 返信をつけるか */
  addReplyButton: boolean;

  /** 送信者ID */
  writerId: string;
  /** 送信者名 */
  writtenBy: string;

  /** 添付ファイルのS3URL */
  fileUrls: Array<string>;
  /** 添付ファイル名 */
  fileNames: Array<string>;

  /** 種別 */
  type: SendMessageType;
}
